import script from "./productModel.vue?vue&type=script&setup=true&lang=js"
export * from "./productModel.vue?vue&type=script&setup=true&lang=js"

import "./productModel.vue?vue&type=style&index=0&id=7d9e3121&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d9e3121"]])

export default __exports__